import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import { useSelector } from 'react-redux';
import { getSubscriptions } from 'email-management-lib/refactor/selectors/manage/table';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SubscriptionCell({
  crmObject,
  propertyName
}) {
  const subscriptionId = getPropertyValue(crmObject, propertyName);
  const subscriptions = useSelector(getSubscriptions);
  if (!subscriptionId) {
    return /*#__PURE__*/_jsx("span", {
      children: "--"
    });
  }
  const subscription = subscriptions.find(s => s.value === subscriptionId);
  if (!subscription) {
    return /*#__PURE__*/_jsx("span", {
      children: "--"
    });
  }
  return /*#__PURE__*/_jsx("span", {
    children: subscription && subscription.text
  });
}